// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zxqH","type":"styles_type__1M1Kx","choices":"styles_choices__3V64m"};